<template>
  <textarea
    class="import-area bg-input"
    @input="onImport($event)"
    v-bind:placeholder="$t('components.fleet.import')"
  ></textarea>
</template>

<script>
import { FleetImporter } from "@/services/fleet-importer";

export default {
  name: "FleetImportArea",
  props: {
    role: {
      type: String,
      default: null
    }
  },
  methods: {
    onImport(event) {
      let data = event.target.value;
      if (data == null || data.length === 0) {
        return;
      }
      event.target.value = "";
      let imported = FleetImporter.import(data, this.role);
      this.$emit("import", imported);
      this.clearSelection();
    },
    clearSelection() {
      if (window.getSelection) {
        window.getSelection().removeAllRanges();
      } else if (document.selection) {
        document.selection.empty();
      }
    }
  }
};
</script>

<style scoped>
.import-area {
  width: 100%;
  height: 6.5em;
  color: var(--color-text-reg);
  resize: none;
}
</style>
